import React from 'react';
import { ArrowRight, Shield, Users } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-layout-v2">
          <div className="hero-main-content">
            {/* Brand badge removed as requested */}
            
            <h1 className="hero-title-redesigned">
              Secure Your Business with 
              <span className="hero-highlight"> Expert Consultancy</span>
            </h1>
            
            <p className="hero-tagline">
              Custom Network Solutions • Security Assessments • Risk Management • 24/7 Support
            </p>
            
            <p className="hero-description-new">
              From network design to cybersecurity audits, we in <span className="brand-name">1stHand Consultancy LTD</span> delivers 
              comprehensive IT consultancy services that protect and empower your business growth. Trusted by businesses across the UK 
              to secure their digital infrastructure and enable confident digital transformation.
            </p>
            
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">100+</div>
                <div className="stat-label">Projects Completed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support Available</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">20+</div>
                <div className="stat-label">Years Experience</div>
              </div>
            </div>
            
            <div className="hero-cta-section">
              <Button 
                onClick={() => scrollToSection('contact')} 
                className="hero-cta-primary"
              >
                Get Free Consultation
                <ArrowRight size={18} />
              </Button>
              <Button 
                onClick={() => scrollToSection('services')} 
                variant="outline" 
                className="hero-cta-secondary"
              >
                View Our Services
              </Button>
            </div>
          </div>
          
          <div className="hero-visual-section">
            <div className="hero-logo-showcase">
              <img 
                src="/logo.png" 
                alt="1stHand Consultancy Ltd Logo" 
                className="hero-logo-redesigned"
              />
              <div className="hero-trust-badges">
                <div className="trust-item">
                  <Shield size={20} />
                  <span>Protect</span>
                </div>
                <div className="trust-item">
                  <Users size={20} />
                  <span>Trust</span>
                </div>
                <div className="trust-item">
                  <ArrowRight size={20} />
                  <span>Innovate</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;